import React from "react";
import CustomSelect from "../CustomSelect/CustomSelect";
// Added Hospital icon import
import { Book, ArrowLeft, Hospital } from "lucide-react"; 

const StepOne = ({ 
  selectedHospital,
  selectedHospitalId,
  handleHospitalSelect,
  isNewTopic,
  topicName,
  setTopicName,
  topics,
  selectedTopicId,
  handleTopicSelect,
  topicsLoading,
  handleNextStep,
  handleCancel
}) => {
  return (
    <div className="training-step-content">
      <div className="training-select-field">
        <div className="training-field-label">בית חולים</div>
        {/* Updated structure for hospital display */}
        <div className="training-hospital-display">
          <Hospital size={18} className="training-hospital-icon" />
          <span className={`training-hospital-name ${!selectedHospital ? 'loading-text' : ''}`}>
            {selectedHospital ? selectedHospital.nameHebrew : 'טוען...'}
          </span>
        </div>
      </div>
      
      {isNewTopic ? (
        <div className="training-select-field">
          <div className="training-field-label">שם הנושא החדש</div>
          <input
            type="text"
            className="training-text-input"
            placeholder="הכנס שם לנושא החדש"
            value={topicName}
            onChange={(e) => setTopicName(e.target.value)}
          />
        </div>
      ) : (
        <div className="training-select-field">
          <div className="training-field-label">בחירת נושא למבחן</div>
          <CustomSelect
            value={selectedTopicId}
            onSelect={handleTopicSelect}
            options={topics.map(t => ({
              id: t.id,
              label: t.name,
              icon: Book
            }))}
            placeholder="בחר נושא"
            disabled={!selectedHospitalId || topicsLoading}
          />
        </div>
      )}
      
      <div className="training-buttons-container">
        <button 
          className="training-button training-button-secondary"
          onClick={handleCancel}
        >
          ביטול
        </button>
        <button 
          className="training-button training-button-primary"
          onClick={handleNextStep}
          disabled={!selectedHospitalId || (isNewTopic ? !topicName.trim() : !selectedTopicId)}
        >
          המשך
          <ArrowLeft size={16} />
        </button>
      </div>
    </div>
  );
};

export default StepOne;